var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { on: { click: _vm.trackClickEvent } }, [
    _c(
      "div",
      {
        staticClass: "hotview_wrap",
        attrs: {
          "data-view-imp-id": _vm.article.itemId,
          "data-tesla-feedback": _vm.article.teslaFeedback
            ? JSON.stringify(_vm.article.teslaFeedback)
            : null
        }
      },
      [
        _c(
          "a",
          {
            staticClass: "thumb_hotview",
            class: _vm.CAT,
            attrs: { href: _vm.linkUrl }
          },
          [
            _c("img", {
              staticClass: "img_thumb",
              attrs: { src: _vm.thumbnailUrl, alt: _vm.altMessage }
            }),
            _vm._v(" "),
            !_vm.hasImage
              ? _c("span", { staticClass: "wrap_txt" }, [
                  _c("span", { staticClass: "inner_txt" }, [
                    _c("span", { staticClass: "txt_thumb" }, [
                      _c("span", { staticClass: "txt_cont" }, [
                        _vm._v(_vm._s(_vm.article.content))
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "detail_hotview" }, [
          _c(
            "a",
            {
              staticClass: "desc_hotview",
              class: _vm.CAT,
              attrs: { href: _vm.linkUrl }
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "cmt_empty",
              class: _vm.CAT,
              attrs: { href: _vm.linkUrl }
            },
            [
              _vm._v("댓글 "),
              _c("span", { staticClass: "num_placeholder" }, [
                _vm._v(_vm._s(_vm.article.commentCount))
              ])
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }